import React from 'react';
import '../less/diia.less';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../auxiliary-components/shared/HeroBlock';
import CardOrderModal from '../../../../auxiliary-components/CardOrderModal';
import { diiaCardTerms } from '../../../../services/urls/urls';
import Tariffs from '../../../../auxiliary-components/shared/TariffsBlock';
import AdditionalProduct from '../../../../auxiliary-components/shared/AdditionalProductBlock';
import QuestionsAdminNew from '../../../../auxiliary-components/shared/QuestionsAdminNew';
import FilesForDownloadNew from "../../../../auxiliary-components/shared/FilesForDownloadNew";
import Tabs from '../../../../auxiliary-components/shared/Tabs';
import TextAboveFooterNew from "../../../../auxiliary-components/shared/TextAboveFooterNew";
import Advantages from '../../../../auxiliary-components/shared/AdvantagesBlock';
import InfoBlock from '../../../../auxiliary-components/shared/InfoBlock';
import FAQStorybook from '@abank/abank-faq';
import ebook_img from '../img/ebook_img.svg';
import esport_img from '../img/esport_img.svg';
import screening_img from '../img/screening_img.svg';
import TextBlock from '../../../../auxiliary-components/shared/TextBlock';
import tariffsData from '../enums/tariffs_data.json';
import additionalCards from '../enums/additional_cards_data.json';
import advantagesItems2 from '../enums/advantages_items_02.json'
import AdvantagesAdmin from '../../../../auxiliary-components/shared/AdvantagesBlockAdmin';
import { filterByEnvironment } from '../../../../helpers/utils/environmentFilter';
import { howToGetCardItems } from '../../enums/howToGetCardData';
import HowToBlockNew from '../../../../auxiliary-components/shared/HowToBlockNew';

export default function template() {
    const page = 'diia-card-new';

    const tabs = [{tab: 'tariffs', title: 'DIIA_CARD_NEW_TABS_01_TITLE_01'},
          {tab: 'how-to-get-card', title: 'CARDS_COMMON_NEW_HOW_TO_GET_CARD_TAB_TITLE'}];

    const tabsInfo = [{tab: 'ebook', title: 'DIIA_CARD_NEW_TABS_INFO_TITLE_01'},
          {tab: 'esport', title: 'DIIA_CARD_NEW_TABS_INFO_TITLE_02'},
          {tab: 'screening', title: 'DIIA_CARD_NEW_TABS_INFO_TITLE_03'},
          {tab: 'childcare', title: 'DIIA_CARD_NEW_TABS_INFO_TITLE_04'}];

    const tabsShortQuestions = [{tab: 'general-questions-short', title: 'DIIA_CARD_NEW_TABS_TITLE_01'},
        {tab: 'childcare-questions-short', title: 'DIIA_CARD_NEW_TABS_INFO_TITLE_CHILDCARE'},
        {tab: 'esport-questions-short', title: 'DIIA_CARD_NEW_TABS_TITLE_03'},
        {tab: 'base-social-help-questions-short', title: 'DIIA_CARD_NEW_TABS_TITLE_05'},
        {tab: 'health-screening-questions-short', title: 'DIIA_CARD_NEW_TABS_TITLE_07'},
        {tab: 'insurance-veterans-questions-short', title: 'DIIA_CARD_NEW_TABS_TITLE_08'},
        {tab: 'ebook-questions-short', title: 'DIIA_CARD_NEW_TABS_TITLE_02'},
        {tab: 'malyatko-questions-short', title: 'DIIA_CARD_NEW_TABS_TITLE_MALYATKO'}];

    const tabsAllQuestions = [{tab: 'general-questions-full', title: 'DIIA_CARD_NEW_TABS_TITLE_01'},
        {tab: 'childcare-questions-full', title: 'DIIA_CARD_NEW_TABS_INFO_TITLE_CHILDCARE'},
        {tab: 'esport-questions-full', title: 'DIIA_CARD_NEW_TABS_TITLE_03'},
        {tab: 'base-social-help-questions-full', title: 'DIIA_CARD_NEW_TABS_TITLE_05'},
        {tab: 'health-screening-questions-full', title: 'DIIA_CARD_NEW_TABS_TITLE_07'},
        {tab: 'insurance-veterans-questions-full', title: 'DIIA_CARD_NEW_TABS_TITLE_08'},
        {tab: 'ebook-questions-full', title: 'DIIA_CARD_NEW_TABS_TITLE_02'},
        {tab: 'malyatko-questions-full', title: 'DIIA_CARD_NEW_TABS_TITLE_MALYATKO'}];

    const hero_data = {
      title: 'DIIA_CARD_NEW_HERO_TITLE',
      text: 'DIIA_CARD_NEW_HERO_TEXT',
      link: {
        text: "DIIA_CARD_NEW_HERO_BTN",
        onClick: () => this.toggleModal(),
      },
      cards: [
        {
          title: 'DIIA_CARD_NEW_CARDS_HERO_TITLE_01',
          text: 'DIIA_CARD_NEW_CARDS_HERO_TEXT_01',
        },
        {
          title: 'DIIA_CARD_NEW_CARDS_HERO_TITLE_02',
          text: 'DIIA_CARD_NEW_CARDS_HERO_TEXT_02',
        },
        {
          title: 'DIIA_CARD_NEW_CARDS_HERO_TITLE_03',
          text: 'DIIA_CARD_NEW_CARDS_HERO_TEXT_03',
        }
      ]
    };

    const questionsWidgets = [
      this.widgetsHelper.getWidgetFrom.call(this, 'widgets_5', 'questions'),
      this.widgetsHelper.getWidgetFrom.call(this, 'widgets_childcare', 'questions'),
      this.widgetsHelper.getWidget_2.call(this, 'questions'),
      this.widgetsHelper.getWidgetFrom.call(this, 'widgets_4', 'questions'),
      this.widgetsHelper.getWidgetFrom.call(this, 'widgets_7', 'questions'),
      this.widgetsHelper.getWidgetFrom.call(this, 'widgets_8', 'questions'),
      this.widgetsHelper.getWidget.call(this, 'questions'),
      this.widgetsHelper.getWidgetFrom.call(this, 'widgets_malyatko', 'questions')
    ];

    return (
        <div className="diia-card-new">
          <Hero
            data={hero_data}
            img={hero_img}
            page={page}
          />
          <div className="content">
            {!this.state.faqTab ? (
              <>
                <div className='first-block'>
                  <TextBlock
                    text={'DIIA_CARD_NEW_TEXT_1'}
                    className="diia-card-new-text-top"
                  />
                  <AdvantagesAdmin
                    data={this.widgetsHelper.getWidget.call(this, 'green_text_block')}
                    loader={this.state.loader}
                  />
                  <TextBlock
                    text={'DIIA_CARD_NEW_TEXT_2'}
                    className="diia-card-new-text-bottom"
                  />
                  {[1, 2, 3].map(i => (
                    <InfoBlock
                      key={i}
                      title={`DIIA_CARD_NEW_INFO_TITLE_${i}`}
                      text={`DIIA_CARD_NEW_INFO_TEXT_${i}`}
                    />
                  ))}
                </div>
                <Tabs tabs={tabsInfo} toggle={this.toggleInfoTab} tab={this.state.tabInfo} id='info-new-tabs' page={page}>
                  <InfoBlock
                    title={'DIIA_CARD_NEW_INFO_TITLE_4'}
                    text={'DIIA_CARD_NEW_INFO_TEXT_4'}
                    headText={'DIIA_CARD_NEW_INFO_TITLE_HEAD_4'}
                    img={ebook_img}
                  />
                  <InfoBlock
                    title={'DIIA_CARD_NEW_INFO_TITLE_5'}
                    text={'DIIA_CARD_NEW_INFO_TEXT_5'}
                    headText={'DIIA_CARD_NEW_INFO_TITLE_HEAD_5'}
                    img={esport_img}
                  />
                  <div className="winter-support-tab-content">
                    <InfoBlock
                      title={'DIIA_CARD_NEW_INFO_TITLE_9'}
                      text={'DIIA_CARD_NEW_INFO_TEXT_9'}
                      headText={'DIIA_CARD_NEW_INFO_TITLE_HEAD_8'}
                      img={screening_img}
                    />
                    <InfoBlock
                      text={'DIIA_CARD_NEW_INFO_TEXT_10'}
                    />
                  </div>
                  <div className="childcare-tab-content">
                    <InfoBlock
                      title={'DIIA_CARD_NEW_INFO_TITLE_11'}
                      text={'DIIA_CARD_NEW_INFO_TEXT_11'}
                      headText={'DIIA_CARD_NEW_INFO_TITLE_HEAD_11'}
                    />
                    <InfoBlock
                      title={'DIIA_CARD_NEW_INFO_TITLE_12'}
                      text={'DIIA_CARD_NEW_INFO_TEXT_12'}
                    />
                  </div>
                </Tabs>
                <Advantages
                  items={advantagesItems2}
                  title={'DIIA_CARD_NEW_ADVANTAGES_TITLE'}
                  className="diia-card-new__advantages_2"
                />
                <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab}>
                  <Tariffs
                    items={tariffsData}
                    title={'DIIA_CARD_NEW_CARDS_TARIFFS_TITLE'}
                    btnLink={diiaCardTerms}
                    btnText={'DIIA_CARD_NEW_CARDS_TARIFFS_BTN'}
                    page={page}
                  />
                  <HowToBlockNew
                    title={'CARDS_COMMON_NEW_HOW_TO_GET_CARD_TITLE'}
                    items={howToGetCardItems}
                  />
                </Tabs>
                <AdditionalProduct
                  items={additionalCards}
                  title={'DIIA_CARD_NEW_ADDITIONAL_PRODUCT_TITLE'}
                  page={page}
                />
                <Tabs tabs={tabsShortQuestions} toggle={this.toggleShortQuestionTab} tab={this.state.tabShortQuestions} title={'DIIA_CARD_NEW_TABS_2_TITLE'} page={page} showArrows={true}>
                  {questionsWidgets.map((widget, i) => (
                    <QuestionsAdminNew
                      key={i}
                      page={page}
                      widget={widget}
                      toggleFaqTab={this.toggleFaqTab}
                    />
                  ))}
                </Tabs>
                <FilesForDownloadNew
                  lang={this.props.lang}
                  widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
                />
                <TextAboveFooterNew
                  widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}
                />
              </>
            ) : (
              <Tabs tabs={tabsAllQuestions} toggle={this.toggleAllQuestionsTab} tab={this.state.tabAllQuestions} showArrows={true}>
                {questionsWidgets.map((widget, i) => (
                  <FAQStorybook
                    key={i}
                    widget={widget}
                    title={this.l10n('DIIA_CARD_NEW_FAQ_STORYBOOK_TITLE')}
                    btnText={this.l10n('DIIA_CARD_NEW_FAQ_STORYBOOK_BTN_TEXT')}
                    onBtnClick={this.toggleFaqTab}
                    filterByEnvironment={filterByEnvironment}
                  />
                ))}
              </Tabs>
            )}
          </div>
          {this.state.showModal ?
            <CardOrderModal closeModal={this.toggleModal} product={"diia"} isOpen={this.state.showModal}/> : ''
          }
        </div>
    );
}
